import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Play, Settings, Flag, Home } from 'lucide-react';
import { SettingsScreen, GameSettings } from '../settings/SettingsScreen';
interface PauseMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onResign: () => void;
  onHome: () => void;
  settings: GameSettings;
  onSettingsChange: (settings: GameSettings) => void;
}
export function PauseMenu({
  isOpen,
  onClose,
  onResign,
  onHome,
  settings,
  onSettingsChange
}: PauseMenuProps) {
  const [showSettings, setShowSettings] = useState(false);
  return <>
      <Modal isOpen={isOpen} onClose={onClose} title="Game Paused" data-id="element-132">
        <div className="space-y-3" data-id="element-133">
          <Button fullWidth size="lg" onClick={onClose} className="gap-2" data-id="element-134">
            <Play size={20} data-id="element-135" />
            Resume Game
          </Button>

          <Button fullWidth size="lg" variant="outline" className="gap-2" onClick={() => setShowSettings(true)} data-id="element-136">
            <Settings size={20} data-id="element-137" />
            Settings
          </Button>

          <Button fullWidth size="lg" variant="outline" onClick={onHome} className="gap-2" data-id="element-138">
            <Home size={20} data-id="element-139" />
            Exit to Home
          </Button>

          <div className="pt-2 border-t border-slate-200" data-id="element-140">
            <Button fullWidth size="lg" variant="danger" onClick={onResign} className="gap-2" data-id="element-141">
              <Flag size={20} data-id="element-142" />
              Resign
            </Button>
          </div>
        </div>
      </Modal>

      <SettingsScreen isOpen={showSettings} onClose={() => setShowSettings(false)} settings={settings} onSave={newSettings => {
      onSettingsChange(newSettings);
      setShowSettings(false);
    }} data-id="element-143" />
    </>;
}